// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wa_a bhf_b","TwoDimsListFeature__item":"wa_b bhf_wb","TwoDimsListFeature__item__text":"wa_c bhf_vr"};